import React from 'react';
import { useNavigate } from 'react-router-dom';
import { PenIcon } from '../../appearence/icons/pen_icon';
import {IconWrapper} from "../../appearence/icons/icon_wrapper";

const PreferencesListEditPreference = ({preferenceId}) => {
    const navigate = useNavigate();

    const navigateOnEditPage = () => {
        navigate(`/preference/item/${preferenceId}`);
    };

    return (
        <IconWrapper handleClick={navigateOnEditPage}><PenIcon handleClick={navigateOnEditPage}/></IconWrapper>
    );
};

export default PreferencesListEditPreference;
